import Hero from "../components/Hero";
import Features from "../components/Features";
import CallToAction from "../components/CallToAction";
import LandingPricingSection from "../components/LandingPricingSection";
import React, { Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/authContext';

// Heavy interactive demo component – load on demand only
const AppDemo = React.lazy(() => import("../components/AppDemo"));


const Index = () => {
  const { isAuthenticated, loading } = useAuth();

  // If the user is authenticated, immediately redirect to the app
  if (!loading && isAuthenticated) {
    return <Navigate to="/app" replace />;
  }

  return (
    <div
      className="min-h-screen overflow-x-hidden"
      style={{
        width: '100vw',
        minWidth: '100%',
        maxWidth: '100vw',
        margin: 0,
        padding: 0,
        paddingTop: '64px', // Account for fixed header height
        boxSizing: 'border-box',
        position: 'relative',
        marginLeft: 'calc(-50vw + 50%)',
        marginRight: 'calc(-50vw + 50%)',
      }}
    >
      <Hero />
      {/* Bring the interactive demo right under the hero to showcase capability */}
      <Suspense fallback={null}>
        <AppDemo />
      </Suspense>
      <Features />
      <LandingPricingSection />
      {/* <Testimonials /> */}
      <CallToAction />
    </div>
  );
};

export default Index;
